import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { white, text, info, secondary } = colors;
const { size } = typography;

const contained = {
  base: {
    backgroundColor: white.main,
    minHeight: pxToRem(32),
    color: text.main,
    border: `1px solid ${colors.divider}`,
    padding: `${pxToRem(5)} ${pxToRem(16)}`,

    "&:hover": {
      backgroundColor: white.main,
    },

    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.85,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(24),
    padding: `${pxToRem(2)} ${pxToRem(10)}`,
    fontSize: size.xs,
    borderRadius: pxToRem(4),

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(40),
    padding: `${pxToRem(8)} ${pxToRem(20)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    borderColor: "transparent",
    backgroundColor: colors.primary.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: colors.primary.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.primary.focus,
      color: `${white.main} !important`,
    },
  },

  secondary: {
    borderColor: "transparent",
    backgroundColor: secondary.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: secondary.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: secondary.focus,
      color: `${white.main} !important`,
    },
  },

  success: {
    borderColor: "transparent",
    backgroundColor: colors.success.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: colors.success.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.success.focus,
      color: `${white.main} !important`,
    },
  },

  warning: {
    borderColor: "transparent",
    backgroundColor: colors.warning.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: colors.warning.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.warning.focus,
      color: `${white.main} !important`,
    },
  },

  error: {
    borderColor: "transparent",
    backgroundColor: colors.error.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: colors.error.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.error.focus,
      color: `${white.main} !important`,
    },
  },

  info: {
    borderColor: "transparent",
    backgroundColor: info.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: info.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: info.focus,
      color: `${white.main} !important`,
    },
  },

  dark: {
    borderColor: "transparent",
    backgroundColor: colors.dark.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: colors.dark.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.dark.focus,
      color: `${white.main} !important`,
    },
  },
};

export default contained;
